import { create } from 'zustand';
import { combine } from 'zustand/middleware';

import { HomeFilterType } from '@/slw/entities/home/home.model';

export const useSearchResultsStore = create(
  combine(
    {
      homeFilter: {} as Omit<HomeFilterType, 'make' | 'country'>,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setValue: (...args: any) => {},
    },
    (set) => {
      return {
        updateSetValue: (setValue: (...args: any) => void) => {
          set({ setValue });
        },
        storeHomeFilter: (homeFilter: Omit<HomeFilterType, 'make'>) => {
          set({ homeFilter });
        },
      };
    },
  ),
);
